import './wordcloud_widget_view.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.TwitterWordsCloudChartView extends Monitoring.Views.Charts.WordcloudWidgetView

  jobName: 'twitter_words'

  initialize: (@options={}) ->
    super($.extend(@options, {
      title: I18n.t('monitoring.dashboard.charts.ranking.cloud.twitter_title')
    }))

  metricsSpecification: ->
    [
      {
        name: I18n.t('monitoring.dashboard.charts.ranking.cloud.contents'),
        key: 'count'
      },
      {
        name: I18n.t('monitoring.dashboard.charts.ranking.cloud.unique_users'),
        key: 'unique_users_count'
      }
      ,
      {
        name: I18n.t('monitoring.dashboard.charts.ranking.cloud.potential_impressions'),
        key: 'sum_twitter_metrics_potential_impressions'
      }
    ]

  searchQueryFor: (topic) =>
    query = super(topic)
    if query.get('sub_type').length == 0
      query.set('sub_type', ['tweet', 'retweet', 'quote'])
    query
